import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState, useEffect } from "react";
import { subirDatos, eliminarDato } from './syncSupabase';
import { authHeader } from './supabase';

const estadoDocColor = { vigente: "#22c55e", revision: "#f59e0b", obsoleto: "#e63946", borrador: "#3b82f6" };
const estadoDocLabel = { vigente: "✅ Vigente", revision: "🔄 En revisión", obsoleto: "⛔ Obsoleto", borrador: "📝 Borrador" };
const normasOpciones = ["ISO 9001:2015", "ISO 14001:2015", "ISO 45001", "FSC", "BPM", "FSSC 22000", "General"];

function fechaHoy() { return new Date().toISOString().slice(0, 10); }
function generarCodigo(lista, prefijo = "PG") {
  const anio = new Date().getFullYear();
  const num = String(lista.length + 1).padStart(2, "0");
  return `${prefijo}-${anio}-${num}`;
}

const STORAGE_DOCS = 'alqos_docs';
const storage = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch { return []; } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch { return false; } },
};

export default function Documentos({ onVolver, oscuro, usuario }) {
  const [docs, setDocs] = useState([]);
  const [cargando, setCargando] = useState(true);
  useEffect(() => {
    async function cargar() {
      try {
        const { supabase } = await import('./supabase');
        const { data } = await supabase.from('documentos').select('data');
        if (data && data.length > 0) setDocs(data.map(r => r.data));
        else setDocs(storage.get(STORAGE_DOCS));
      } catch { setDocs(storage.get(STORAGE_DOCS)); }
      setCargando(false);
    }
    cargar();
  }, []);
  const [vista, setVista] = useState("listado");
  const [form, setForm] = useState({ estado: "vigente", norma: "ISO 9001:2015", tipo: "PG", fechaVigencia: fechaHoy() });
  const [detalle, setDetalle] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [filtraNorma, setFiltraNorma] = useState("todas");
  const [busqueda, setBusqueda] = useState("");
  const [cargandoARIA, setCargandoARIA] = useState(false);
  const [ariaResultado, setAriaResultado] = useState(null);
  const [docParaValidar, setDocParaValidar] = useState(null);

  if (cargando) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background: oscuro?"#09184D":"#F0EEFF" }}>
      <p style={{ color: oscuro?"white":"#09184D", fontSize:"16px" }}>Cargando documentos...</p>
    </div>
  );

  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const esAdmin = usuario?.rol === "Administrador";

  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: oscuro ? "#9aabd4" : "#555", fontWeight: "600", display: "block", marginTop: "12px" };
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };

  const tiposDoc = [
    { valor: "PG", label: "PG — Procedimiento General" },
    { valor: "FG", label: "FG — Formulario/Registro" },
    { valor: "IT", label: "IT — Instructivo" },
    { valor: "MA", label: "MA — Manual" },
    { valor: "PL", label: "PL — Plan" },
    { valor: "RE", label: "RE — Reglamento" },
  ];

  const camposDoc = [
    { key: "titulo", label: "Título del documento" },
    { key: "descripcion", label: "Descripción / Alcance" },
    { key: "responsable", label: "Responsable del documento" },
    { key: "elaboradoPor", label: "Elaborado por" },
    { key: "revisadoPor", label: "Revisado por" },
    { key: "aprobadoPor", label: "Aprobado por" },
    { key: "version", label: "Versión (ej: 1.0, 2.0)" },
    { key: "fechaVigencia", label: "Fecha de vigencia" },
    { key: "fechaProximaRevision", label: "Fecha próxima revisión" },
    { key: "ubicacion", label: "Ubicación física / link" },
    { key: "linkExterno", label: "🔗 Link directo al documento (Drive, SharePoint, servidor)" },
    { key: "observaciones", label: "Observaciones" },
  ];

  const guardar = () => {
    const nuevo = {
      ...form,
      id: Date.now(),
      codigo: generarCodigo(docs, form.tipo || "PG"),
      fechaCreacion: new Date().toISOString(),
      creadoPor: usuario?.nombre || "Sistema",
      rolCreador: usuario?.rol || "",
    };
    const nuevos = [...docs, nuevo];
    setDocs(nuevos);
    storage.set(STORAGE_DOCS, nuevos);
    subirDatos(STORAGE_DOCS);
    setForm({ estado: "vigente", norma: "ISO 9001:2015", tipo: "PG", fechaVigencia: fechaHoy() });
    setVista("listado");
  };

  const eliminar = async (id) => {
    const nuevos = docs.filter(d => d.id !== id);
    setDocs(nuevos);
    storage.set(STORAGE_DOCS, nuevos);
    await eliminarDato(STORAGE_DOCS, id);
    setConfirmEliminar(null);
    setDetalle(null);
    setVista("listado");
  };


  const subirPDFyAnalizar = async (docId, archivo) => {
    const tiposPermitidos = ['application/pdf','image/jpeg','image/png','image/jpg','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel'];
    if (!archivo || !tiposPermitidos.includes(archivo.type)) { alert('Formatos aceptados: PDF, JPG, PNG, Excel (.xlsx/.xls)'); return; }
    setCargandoARIA(true);
    setAriaResultado(null);
    try {
      // 1. Subir PDF a Supabase Storage
      const { supabase } = await import('./supabase');
      if (!usuario?.tenant_id) throw new Error('Sesión sin tenant_id -- no se puede subir el archivo.');
      const ext = archivo.name.split('.').pop().toLowerCase();
      const nombreArchivo = `${usuario.tenant_id}/${docId}_${Date.now()}.${ext}`;
      const { error: uploadError } = await supabase.storage
        .from('documentos')
        .upload(nombreArchivo, archivo, { contentType: archivo.type, upsert: true });
      if (uploadError) throw new Error('Error al subir PDF: ' + uploadError.message);

      // 2. Preparar contenido para ARIA según tipo de archivo
      const esPDF = archivo.type === 'application/pdf';
      const esImagen = archivo.type.startsWith('image/');
      const esExcel = archivo.type.includes('spreadsheet') || archivo.type.includes('excel') || archivo.name.endsWith('.xlsx') || archivo.name.endsWith('.xls');

      const base64 = await new Promise((res, rej) => {
        const reader = new FileReader();
        reader.onload = () => res(reader.result.split(',')[1]);
        reader.onerror = rej;
        reader.readAsDataURL(archivo);
      });

      let textoExcel = '';
      if (esExcel) {
        // Extraer texto del Excel con SheetJS
        try {
          const XLSX = await import('https://cdn.sheetjs.com/xlsx-0.20.1/package/xlsx.mjs');
          const arrayBuffer = await archivo.arrayBuffer();
          const workbook = XLSX.read(arrayBuffer, { type: 'array' });
          textoExcel = workbook.SheetNames.map(name => {
            const sheet = workbook.Sheets[name];
            return 'Hoja: ' + name + '\n' + XLSX.utils.sheet_to_csv(sheet);
          }).join('\n\n').slice(0, 8000);
        } catch(e) { textoExcel = 'No se pudo leer el Excel: ' + e.message; }
      }

      const promptTexto = `Sos un experto en gestión documental ISO 9001 §7.5. Analizá este documento y extraé la información clave. Respondé SOLO en JSON sin markdown.

JSON exacto:
{
  "titulo": "título del documento",
  "codigo": "código del documento (ej: PG-75-01)",
  "version": "número de versión o revisión",
  "fechaEmision": "YYYY-MM-DD o vacío",
  "fechaVigencia": "YYYY-MM-DD o vacío",
  "elaboradoPor": "nombre o vacío",
  "revisadoPor": "nombre o vacío",
  "aprobadoPor": "nombre o vacío",
  "alcance": "descripción del alcance en 1-2 oraciones",
  "clausulasISO": ["8.1", "9.1.3"],
  "tipoDocumento": "PG o FG o IT o MA o PL",
  "observaciones": "observaciones relevantes para el sistema de gestión"
}${esExcel ? '\n\nContenido del Excel:\n' + textoExcel : ''}`;

      // Construir contenido del mensaje según tipo
      let mensajeContent;
      if (esPDF) {
        mensajeContent = [
          { type: "document", source: { type: "base64", media_type: "application/pdf", data: base64 } },
          { type: "text", text: promptTexto }
        ];
      } else if (esImagen) {
        mensajeContent = [
          { type: "image", source: { type: "base64", media_type: archivo.type, data: base64 } },
          { type: "text", text: promptTexto }
        ];
      } else {
        // Excel u otro — solo texto
        mensajeContent = [{ type: "text", text: promptTexto }];
      }

      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()),
          "Content-Type": "application/json",
          "anthropic-version": "2023-06-01",
          },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 1500,
          messages: [{ role: "user", content: mensajeContent }]
        })
      });

      const data = await response.json();
      const raw = data.content?.[0]?.text || "";
      const limpio = raw.replace(/```json/g,"").replace(/```/g,"").trim();
      const resultado = JSON.parse(limpio);
      resultado.pdfNombre = nombreArchivo;
      setAriaResultado(resultado);
      setDocParaValidar(docId);
    } catch(e) {
      console.error(e);
      alert("Error al analizar con ARIA: " + e.message);
    }
    setCargandoARIA(false);
  };

  const validarDocumento = () => {
    if (!ariaResultado || !docParaValidar) return;
    const entrada = { de: detalle?.estado || 'borrador', a: 'vigente', por: usuario?.nombre, fecha: new Date().toISOString(), via: 'ARIA' };
    const actualizados = docs.map(d => d.id === docParaValidar ? {
      ...d,
      estado: 'vigente',
      pdfNombre: ariaResultado.pdfNombre,
      ariaAlcance: ariaResultado.alcance,
      ariaClausulas: ariaResultado.clausulasISO,
      ariaObservaciones: ariaResultado.observaciones,
      version: ariaResultado.version || d.version,
      fechaVigencia: ariaResultado.fechaVigencia || d.fechaVigencia,
      aprobadoPor: ariaResultado.aprobadoPor || d.aprobadoPor,
      validadoPor: usuario?.nombre,
      fechaValidacion: new Date().toISOString(),
      historialRevisiones: [...(d.historialRevisiones || []), entrada],
    } : d);
    setDocs(actualizados);
    storage.set(STORAGE_DOCS, actualizados);
    subirDatos(STORAGE_DOCS);
    const docActualizado = actualizados.find(d => d.id === docParaValidar);
    if (detalle?.id === docParaValidar) setDetalle(docActualizado);
    setAriaResultado(null);
    setDocParaValidar(null);
    alert('✅ Documento validado y guardado como vigente.');
  };


  const revisarVencimientoConARIA = async (doc) => {
    if (!doc.pdfNombre) {
      alert("Este documento no tiene PDF cargado. Subí el PDF primero para que ARIA pueda revisarlo.");
      return;
    }
    setCargandoARIA(true);
    setAriaResultado(null);
    try {
      // Firmar la URL al vuelo (no se guarda cacheada -- createSignedUrl expira)
      const { supabase } = await import('./supabase');
      const { data: urlFirmada, error: urlError } = await supabase.storage.from('documentos').createSignedUrl(doc.pdfNombre, 3600);
      if (urlError) throw new Error('No se pudo generar el link del archivo: ' + urlError.message);
      const pdfResp = await fetch(urlFirmada.signedUrl);
      const pdfBlob = await pdfResp.blob();
      const base64 = await new Promise((res, rej) => {
        const reader = new FileReader();
        reader.onload = () => res(reader.result.split(',')[1]);
        reader.onerror = rej;
        reader.readAsDataURL(pdfBlob);
      });

      const diasRestantes = doc.fechaVencimiento
        ? Math.ceil((new Date(doc.fechaVencimiento) - new Date()) / (1000*60*60*24))
        : null;

      const prompt = `Sos un experto en gestión documental ISO 9001 §7.5 y ISO 14001. Este documento está próximo a vencer (${diasRestantes !== null ? diasRestantes + " días restantes" : "fecha de vencimiento no definida"}). 

Datos actuales del documento:
- Código: ${doc.codigo}
- Título: ${doc.titulo}
- Versión actual: ${doc.version || "no definida"}
- Norma: ${doc.norma}
- Fecha vigencia: ${doc.fechaVigencia || "no definida"}
- Fecha vencimiento: ${doc.fechaVencimiento || "no definida"}
- Aprobado por: ${doc.aprobadoPor || "no definido"}

Analizá el contenido del PDF y determiná si requiere actualización o puede revalidarse. Respondé SOLO en JSON sin markdown:

{
  "requiereActualizacion": true o false,
  "justificacion": "por qué requiere o no actualización",
  "cambiosSugeridos": ["cambio 1", "cambio 2"],
  "nuevaVersion": "número de versión sugerida si requiere cambios, sino la misma",
  "nuevaFechaVencimiento": "YYYY-MM-DD sugerida (2 años desde hoy si se revalida)",
  "clausulasAfectadas": ["8.1", "9.1"],
  "accionRecomendada": "revalidar" o "actualizar" o "obsoleto",
  "observaciones": "observación final para el responsable del SGI"
}`;

      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()),
          "Content-Type": "application/json",
          "anthropic-version": "2023-06-01",
          },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 1500,
          messages: [{
            role: "user",
            content: [
              { type: "document", source: { type: "base64", media_type: "application/pdf", data: base64 } },
              { type: "text", text: prompt }
            ]
          }]
        })
      });

      const data = await response.json();
      const raw = data.content?.[0]?.text || "";
      const limpio = raw.replace(/```json/g,"").replace(/```/g,"").trim();
      const resultado = JSON.parse(limpio);
      resultado._tipo = "revision_vencimiento";
      resultado._docId = doc.id;
      setAriaResultado(resultado);
      setDocParaValidar(doc.id);
    } catch(e) {
      console.error(e);
      alert("Error al revisar con ARIA: " + e.message);
    }
    setCargandoARIA(false);
  };

  const aplicarRevisionARIA = () => {
    if (!ariaResultado || !docParaValidar) return;
    const accion = ariaResultado.accionRecomendada;
    const nuevoEstado = accion === "obsoleto" ? "obsoleto" : accion === "actualizar" ? "revision" : "vigente";
    const entrada = {
      de: detalle?.estado,
      a: nuevoEstado,
      por: usuario?.nombre,
      fecha: new Date().toISOString(),
      via: "ARIA revisión vencimiento",
      justificacion: ariaResultado.justificacion,
    };
    const actualizados = docs.map(d => d.id === docParaValidar ? {
      ...d,
      estado: nuevoEstado,
      version: ariaResultado.nuevaVersion || d.version,
      fechaVencimiento: ariaResultado.nuevaFechaVencimiento || d.fechaVencimiento,
      ariaObservaciones: ariaResultado.observaciones,
      ariaClausulas: ariaResultado.clausulasAfectadas,
      ultimaRevisionARIA: new Date().toISOString(),
      historialRevisiones: [...(d.historialRevisiones || []), entrada],
    } : d);
    setDocs(actualizados);
    storage.set(STORAGE_DOCS, actualizados);
    subirDatos(STORAGE_DOCS);
    if (detalle?.id === docParaValidar) setDetalle(prev => ({
      ...prev,
      estado: nuevoEstado,
      version: ariaResultado.nuevaVersion || prev.version,
      fechaVencimiento: ariaResultado.nuevaFechaVencimiento || prev.fechaVencimiento,
      ariaObservaciones: ariaResultado.observaciones,
    }));
    setAriaResultado(null);
    setDocParaValidar(null);
    alert("✅ Revisión aplicada — estado: " + nuevoEstado);
  };


  const verArchivo = async (doc) => {
    if (!doc.pdfNombre) return;
    try {
      const { supabase } = await import('./supabase');
      const { data, error } = await supabase.storage.from('documentos').createSignedUrl(doc.pdfNombre, 3600);
      if (error) throw error;
      window.open(data.signedUrl, '_blank', 'noopener,noreferrer');
    } catch(e) {
      alert('No se pudo abrir el archivo: ' + e.message);
    }
  };

  const eliminarArchivo = async (doc) => {
    if (!doc.pdfNombre) { alert("No hay archivo cargado."); return; }
    if (!window.confirm("¿Eliminar el archivo adjunto de este documento?")) return;
    try {
      const { supabase } = await import('./supabase');
      await supabase.storage.from('documentos').remove([doc.pdfNombre]);
      const actualizados = docs.map(d => d.id === doc.id ? { ...d, pdfNombre:'', validadoPor:'', fechaValidacion:'' } : d);
      setDocs(actualizados);
      storage.set(STORAGE_DOCS, actualizados);
      subirDatos(STORAGE_DOCS);
      if (detalle?.id === doc.id) setDetalle(prev => ({ ...prev, pdfNombre:'', validadoPor:'', fechaValidacion:'' }));
      alert("Archivo eliminado.");
    } catch(e) {
      console.error(e);
      alert("Error al eliminar: " + e.message);
    }
  };

  const cambiarEstado = (id, nuevoEstado) => {
    const doc = docs.find(d => d.id === id);
    const entrada = { de: doc?.estado, a: nuevoEstado, por: usuario?.nombre, fecha: new Date().toISOString() };
    const actualizados = docs.map(d => d.id === id ? {
      ...d, estado: nuevoEstado,
      ultimoCambio: new Date().toISOString(),
      cambiadoPor: usuario?.nombre,
      historialRevisiones: [...(d.historialRevisiones || []), entrada]
    } : d);
    setDocs(actualizados);
    storage.set(STORAGE_DOCS, actualizados);
    subirDatos(STORAGE_DOCS);
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: nuevoEstado, historialRevisiones: [...(prev.historialRevisiones||[]), entrada] }));
  };

  const actualizarCampo = (id, campo, valor) => {
    const actualizados = docs.map(d => d.id === id ? { ...d, [campo]: valor } : d);
    setDocs(actualizados);
    storage.set(STORAGE_DOCS, actualizados);
    subirDatos(STORAGE_DOCS);
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, [campo]: valor }));
  };

  const docsFiltrados = docs.filter(d => {
    const matchEstado = filtroEstado === "todos" || d.estado === filtroEstado;
    const matchNorma = filtraNorma === "todas" || d.norma === filtraNorma;
    const matchBusqueda = !busqueda || d.titulo?.toLowerCase().includes(busqueda.toLowerCase()) || d.codigo?.toLowerCase().includes(busqueda.toLowerCase());
    return matchEstado && matchNorma && matchBusqueda;
  });

  const hoy = new Date();
  const proximos30 = docs.filter(d => {
    if (!d.fechaVencimiento || d.estado === 'obsoleto') return false;
    const dias = Math.ceil((new Date(d.fechaVencimiento) - hoy) / (1000*60*60*24));
    return dias >= 0 && dias <= 30;
  });
  const vencidos = docs.filter(d => {
    if (!d.fechaVencimiento || d.estado === 'obsoleto') return false;
    return new Date(d.fechaVencimiento) < hoy;
  });
  const resumen = {
    total: docs.length,
    vigentes: docs.filter(d => d.estado === "vigente").length,
    revision: docs.filter(d => d.estado === "revision").length,
    obsoletos: docs.filter(d => d.estado === "obsoleto").length,
    proximos30: proximos30.length,
    vencidos: vencidos.length,
  };

  const Header = ({ titulo, onBack, extra }) => (
    <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
        <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
      </div>
      {extra}
    </div>
  );

  if (confirmEliminar) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: cardBg, borderRadius: "16px", padding: "2rem", maxWidth: "360px", width: "90%", border: `1px solid ${borde}`, textAlign: "center" }}>
        <p style={{ fontSize: "32px", marginBottom: "1rem" }}>📁</p>
        <p style={{ fontSize: "15px", fontWeight: "600", color: texto, marginBottom: ".5rem" }}>¿Eliminar este documento?</p>
        <p style={{ fontSize: "13px", color: subtexto, marginBottom: "1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding: "10px 20px", background: "none", border: `1px solid ${borde}`, borderRadius: "10px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
          <button onClick={() => eliminar(confirmEliminar)} style={{ padding: "10px 20px", background: "#e63946", border: "none", borderRadius: "10px", cursor: "pointer", color: "white", fontSize: "13px", fontWeight: "600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  if (vista === "detalle" && detalle) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo={detalle.codigo}
        onBack={() => { setDetalle(null); setVista("listado"); }}
        extra={esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background: "rgba(230,57,70,.2)", border: "1px solid rgba(230,57,70,.4)", color: "#e63946", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "12px" }}>🗑 Eliminar</button>}
      />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "10px" }}>Identificación</h3>
          {detalle.linkExterno && (
            <div style={{ marginBottom:"10px", padding:"10px 14px", background:oscuro?"#0a1f5c":"#eff6ff", borderRadius:"8px", border:"1px solid #2A7FFF40", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <div>
                <p style={{ fontSize:"11px", color:"#2A7FFF", fontWeight:"700", margin:"0 0 2px" }}>🔗 Link al documento</p>
                <p style={{ fontSize:"11px", color:subtexto, margin:0, wordBreak:"break-all" }}>{detalle.linkExterno}</p>
              </div>
              <a href={detalle.linkExterno} target="_blank" rel="noreferrer"
                style={{ padding:"6px 12px", background:"#2A7FFF", color:"white", borderRadius:"8px", fontSize:"12px", fontWeight:"700", textDecoration:"none", flexShrink:0, marginLeft:"10px" }}>
                Abrir →
              </a>
            </div>
          )}
        {[["Código", detalle.codigo], ["Tipo", detalle.tipo], ["Norma relacionada", detalle.norma], ["Creado por", `${detalle.creadoPor} — ${detalle.rolCreador}`], ["Fecha creación", detalle.fechaCreacion?.slice(0, 10)]].map(([k, v]) => v && (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 0", borderBottom: `0.5px solid ${borde}` }}>
              <span style={{ color: subtexto }}>{k}</span>
              <span style={{ color: texto, fontWeight: "500" }}>{v}</span>
            </div>
          ))}
        </div>

        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#7B5BF2", marginBottom: "12px" }}>Estado del documento</h3>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {Object.entries(estadoDocLabel).map(([val, lab]) => (
              <button key={val} onClick={() => esAdmin && cambiarEstado(detalle.id, val)}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: esAdmin ? "pointer" : "default", fontWeight: "600", border: detalle.estado === val ? `2px solid ${estadoDocColor[val]}` : `1px solid ${borde}`, background: detalle.estado === val ? `${estadoDocColor[val]}22` : cardBg, color: detalle.estado === val ? estadoDocColor[val] : subtexto }}>
                {lab}
              </button>
            ))}
          </div>
        </div>

        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#09184D", marginBottom: "12px" }}>Contenido</h3>
          {camposDoc.map(({ key, label }) => {
            const val = detalle[key]; if (!val) return null;
            return (
              <div key={key} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `0.5px solid ${borde}`, fontSize: "13px" }}>
                <span style={{ color: subtexto }}>{label}</span>
                <span style={{ color: texto, fontWeight: "500", maxWidth: "60%", textAlign: "right" }}>{val}</span>
              </div>
            );
          })}
        </div>

        {/* PANEL PDF + ARIA */}
        <div style={{ ...card, background: oscuro?"#0a1f5c":"#f0f8ff", border:"1px solid #3b82f640" }}>
          <h3 style={{ fontSize:"14px", fontWeight:"600", color:"#3b82f6", marginBottom:"8px" }}>📄 Documento PDF + Análisis ARIA</h3>
          {detalle.pdfNombre && (
            <div style={{ marginBottom:"10px", padding:"8px 12px", background: oscuro?"#091840":"white", borderRadius:"8px", border:"1px solid #22c55e40" }}>
              <p style={{ fontSize:"12px", color:"#22c55e", fontWeight:"600", margin:"0 0 4px" }}>✅ PDF cargado y validado</p>
              <div style={{ display:"flex", gap:"10px", alignItems:"center" }}>
                <button onClick={() => verArchivo(detalle)}
                  style={{ padding:0, background:"none", border:"none", cursor:"pointer", fontSize:"12px", color:"#3b82f6", textDecoration:"underline" }}>📎 Ver archivo →</button>
                {esAdmin && (
                  <button onClick={() => eliminarArchivo(detalle)}
                    style={{ padding:"3px 8px", background:"none", border:"1px solid #e63946", color:"#e63946", borderRadius:"6px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                    🗑 Eliminar archivo
                  </button>
                )}
              </div>
              {detalle.validadoPor && <p style={{ fontSize:"11px", color:subtexto, margin:"4px 0 0" }}>Validado por: {detalle.validadoPor} · {detalle.fechaValidacion?.slice(0,10)}</p>}
              {detalle.ariaAlcance && <p style={{ fontSize:"11px", color:subtexto, margin:"4px 0 0" }}>ARIA: {detalle.ariaAlcance}</p>}
              {detalle.ariaClausulas?.length > 0 && <p style={{ fontSize:"11px", color:"#7B5BF2", margin:"4px 0 0" }}>Cláusulas: {detalle.ariaClausulas.join(", ")}</p>}
              {detalle.ultimaRevisionARIA && <p style={{ fontSize:"11px", color:subtexto, margin:"4px 0 0" }}>Última revisión ARIA: {detalle.ultimaRevisionARIA?.slice(0,10)}</p>}
              {esAdmin && (
                <button onClick={() => revisarVencimientoConARIA(detalle)} disabled={cargandoARIA}
                  style={{ marginTop:"8px", padding:"7px 14px", background: cargandoARIA?"rgba(123,91,242,.3)":"linear-gradient(135deg,#7B5BF2,#09184D)", color:"white", border:"none", borderRadius:"8px", cursor: cargandoARIA?"default":"pointer", fontSize:"12px", fontWeight:"600" }}>
                  {cargandoARIA ? "🤖 Analizando..." : "🤖 Revisar vencimiento con ARIA"}
                </button>
              )}
            </div>
          )}
          {esAdmin && (
            <div>
              <div style={{ background: oscuro?"#0a1f5c":"#eff6ff", border:"1px solid #3b82f640", borderRadius:"10px", padding:"10px 14px", marginBottom:"10px" }}>
                <p style={{ fontSize:"12px", fontWeight:"700", color:"#3b82f6", margin:"0 0 4px" }}>📋 Política de documentos ALQOS™</p>
                <p style={{ fontSize:"11px", color:subtexto, margin:"0 0 4px" }}>✅ <strong>Recomendado:</strong> Usá el campo <em>"Link directo"</em> para vincular documentos desde Google Drive, SharePoint o servidor interno. Es más liviano y siempre actualizado.</p>
                <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>📎 <strong>Upload directo:</strong> Solo para documentos que no están en ningún servidor. Se almacenan en Supabase Storage.</p>
              </div>
              <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 8px" }}>Subí el archivo (PDF, JPG, PNG, Excel) — ARIA lo analiza y te muestra el resultado para que lo revisés antes de validar</p>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls" onChange={e => { if(e.target.files[0]) subirPDFyAnalizar(detalle.id, e.target.files[0]); }}
                style={{ fontSize:"12px", color:texto, marginBottom:"8px" }}/>
              {cargandoARIA && <p style={{ fontSize:"12px", color:"#7B5BF2", fontWeight:"600" }}>🤖 ARIA analizando el PDF...</p>}
            </div>
          )}
          {ariaResultado && docParaValidar === detalle.id && (
            <div style={{ marginTop:"10px", background: oscuro?"#091840":"white", borderRadius:"10px", padding:"12px", border:"2px solid #7B5BF2" }}>
              <p style={{ fontSize:"13px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 10px" }}>🤖 ARIA analizó el documento — revisá antes de validar</p>
              {[["Título detectado", ariaResultado.titulo], ["Código", ariaResultado.codigo], ["Versión", ariaResultado.version], ["Fecha vigencia", ariaResultado.fechaVigencia], ["Aprobado por", ariaResultado.aprobadoPor], ["Alcance", ariaResultado.alcance], ["Cláusulas ISO", ariaResultado.clausulasISO?.join(", ")], ["Observaciones", ariaResultado.observaciones]].map(([k,v]) => v && (
                <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"4px 0", borderBottom:`0.5px solid ${borde}`, fontSize:"12px" }}>
                  <span style={{ color:subtexto, fontWeight:"600" }}>{k}</span>
                  <span style={{ color:texto, maxWidth:"60%", textAlign:"right" }}>{v}</span>
                </div>
              ))}
              <div style={{ display:"flex", gap:"8px", marginTop:"12px" }}>
                {ariaResultado._tipo === "revision_vencimiento" ? (
                  <button onClick={aplicarRevisionARIA}
                    style={{ flex:1, padding:"10px", background: ariaResultado.accionRecomendada==="obsoleto"?"#e63946":ariaResultado.accionRecomendada==="actualizar"?"#f59e0b":"#22c55e", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                    {ariaResultado.accionRecomendada==="obsoleto" ? "⛔ Marcar como obsoleto" : ariaResultado.accionRecomendada==="actualizar" ? "🔄 Poner en revisión" : "✅ Revalidar documento"}
                  </button>
                ) : (
                  <button onClick={validarDocumento}
                    style={{ flex:1, padding:"10px", background:"#22c55e", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>
                    ✅ Validar y guardar como vigente
                  </button>
                )}
                <button onClick={() => { setAriaResultado(null); setDocParaValidar(null); }}
                  style={{ padding:"10px 16px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", color:texto, fontSize:"12px" }}>
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>
        {detalle.historialRevisiones && detalle.historialRevisiones.length > 0 && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"600", color:"#7B5BF2", marginBottom:"8px" }}>📋 Historial de revisiones</h3>
            {detalle.historialRevisiones.map((h, i) => (
              <div key={i} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:`0.5px solid ${borde}`, fontSize:"12px" }}>
                <span style={{ color:subtexto }}>{h.fecha?.slice(0,16).replace("T"," ")}</span>
                <span style={{ color:texto }}>{estadoDocLabel[h.de]||h.de} → {estadoDocLabel[h.a]||h.a}</span>
                <span style={{ color:subtexto }}>{h.por}</span>
              </div>
            ))}
          </div>
        )}
        {esAdmin && (
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"600", color:"#09184D", marginBottom:"8px" }}>✏️ Editar campos</h3>
            <span style={lbl}>Ubicación / Link</span>
            <input defaultValue={detalle.ubicacion||""} onBlur={e=>actualizarCampo(detalle.id,"ubicacion",e.target.value)} style={inp} placeholder="URL o ruta del documento"/>
            <span style={lbl}>Observaciones</span>
            <textarea rows={2} defaultValue={detalle.observaciones||""} onBlur={e=>actualizarCampo(detalle.id,"observaciones",e.target.value)} style={{...inp,resize:"none"}}/>
            <span style={lbl}>Fecha próxima revisión</span>
            <input type="date" defaultValue={detalle.fechaProximaRevision||""} onBlur={e=>actualizarCampo(detalle.id,"fechaProximaRevision",e.target.value)} style={inp}/>
            <span style={lbl}>Fecha vencimiento</span>
            <input type="date" defaultValue={detalle.fechaVencimiento||""} onBlur={e=>actualizarCampo(detalle.id,"fechaVencimiento",e.target.value)} style={inp}/>
          </div>
        )}
      </div>
    </div>
  );

  if (vista === "nueva") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo="Nuevo Documento" onBack={() => setVista("listado")} />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "4px" }}>Trazabilidad automática</h3>
          <p style={{ fontSize: "12px", color: subtexto, margin: 0 }}>Creado por: <strong style={{ color: texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>

        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Clasificación</h3>
          <span style={lbl}>Tipo de documento</span>
          <select onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))} style={inp} defaultValue="PG">
            {tiposDoc.map(t => <option key={t.valor} value={t.valor}>{t.label}</option>)}
          </select>
          <span style={lbl}>Norma relacionada</span>
          <select onChange={e => setForm(f => ({ ...f, norma: e.target.value }))} style={inp} defaultValue="ISO 9001:2015">
            {normasOpciones.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
          <span style={lbl}>Estado inicial</span>
          <div style={{ display: "flex", gap: "8px", marginTop: "6px", flexWrap: "wrap" }}>
            {Object.entries(estadoDocLabel).map(([val, lab]) => (
              <button key={val} onClick={() => setForm(f => ({ ...f, estado: val }))}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: "pointer", fontWeight: "600", border: form.estado === val ? `2px solid ${estadoDocColor[val]}` : `1px solid ${borde}`, background: form.estado === val ? `${estadoDocColor[val]}22` : cardBg, color: form.estado === val ? estadoDocColor[val] : texto }}>
                {lab}
              </button>
            ))}
          </div>
        </div>

        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Datos del documento</h3>
          {camposDoc.map(({ key, label }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              <input type={key.includes("fecha") ? "date" : "text"} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} defaultValue={key === "fechaVigencia" ? fechaHoy() : ""} />
            </div>
          ))}
        </div>

        <button onClick={guardar} style={{ width: "100%", padding: "14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: "pointer", marginTop: "1rem" }}>
          Guardar Documento
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <BotonInstructivo moduloKey="documentos" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="documentos" oscuro={oscuro} />}
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>Documentos</span>
        </div>
        {esAdmin && <button onClick={() => setVista("nueva")} style={{ padding: "6px 14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>+ Nuevo</button>}
      </div>

      <div style={{ padding: "1rem 1.5rem" }}>
        {proximos30.length > 0 && (
          <div style={{ background:"#fff8f0", border:"2px solid #f97316", borderRadius:"12px", padding:"12px 16px", marginBottom:"1rem", display:"flex", alignItems:"center", gap:"10px" }}>
            <span style={{ fontSize:"20px" }}>⏰</span>
            <div>
              <p style={{ fontSize:"13px", fontWeight:"700", color:"#f97316", margin:0 }}>{proximos30.length} documento{proximos30.length>1?"s":""} vence{proximos30.length===1?"":"n"} en los próximos 30 días</p>
              <p style={{ fontSize:"11px", color:"#808085", margin:0 }}>{proximos30.map(d=>d.codigo).join(" · ")}</p>
            </div>
          </div>
        )}
        {vencidos.length > 0 && (
          <div style={{ background:"#fff0f0", border:"2px solid #e63946", borderRadius:"12px", padding:"12px 16px", marginBottom:"1rem", display:"flex", alignItems:"center", gap:"10px" }}>
            <span style={{ fontSize:"20px" }}>🔴</span>
            <div>
              <p style={{ fontSize:"13px", fontWeight:"700", color:"#e63946", margin:0 }}>{vencidos.length} documento{vencidos.length>1?"s":""} vencido{vencidos.length>1?"s":""}</p>
              <p style={{ fontSize:"11px", color:"#808085", margin:0 }}>{vencidos.map(d=>d.codigo).join(" · ")}</p>
            </div>
          </div>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: "10px", marginBottom: "1.5rem" }}>
          {[["Total", resumen.total, "#7B5BF2"], ["Vigentes", resumen.vigentes, "#22c55e"], ["En revisión", resumen.revision, "#f59e0b"], ["Obsoletos", resumen.obsoletos, "#e63946"], ["Vencen en 30d", resumen.proximos30, "#f97316"], ["Vencidos", resumen.vencidos, "#e63946"]].map(([lab, val, col]) => (
            <div key={lab} style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1px solid ${borde}`, textAlign: "center" }}>
              <p style={{ fontSize: "22px", fontWeight: "700", color: col, margin: 0 }}>{val}</p>
              <p style={{ fontSize: "11px", color: subtexto, margin: "4px 0 0" }}>{lab}</p>
            </div>
          ))}
        </div>

        <input placeholder="🔍 Buscar por título o código..." value={busqueda} onChange={e => setBusqueda(e.target.value)}
          style={{ ...inp, marginBottom: "1rem", marginTop: 0 }} />

        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1rem" }}>
          <button onClick={() => setFiltroEstado("todos")} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === "todos" ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtroEstado === "todos" ? "rgba(123,91,242,.1)" : cardBg, color: filtroEstado === "todos" ? "#7B5BF2" : subtexto }}>Todos</button>
          {Object.entries(estadoDocLabel).map(([val, lab]) => (
            <button key={val} onClick={() => setFiltroEstado(val)} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === val ? `2px solid ${estadoDocColor[val]}` : `1px solid ${borde}`, background: filtroEstado === val ? `${estadoDocColor[val]}22` : cardBg, color: filtroEstado === val ? estadoDocColor[val] : subtexto }}>{lab}</button>
          ))}
        </div>

        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1rem" }}>
          <button onClick={() => setFiltraNorma("todas")} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtraNorma === "todas" ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtraNorma === "todas" ? "rgba(123,91,242,.1)" : cardBg, color: filtraNorma === "todas" ? "#7B5BF2" : subtexto }}>Todas las normas</button>
          {normasOpciones.map(n => (
            <button key={n} onClick={() => setFiltraNorma(n)} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtraNorma === n ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtraNorma === n ? "rgba(123,91,242,.1)" : cardBg, color: filtraNorma === n ? "#7B5BF2" : subtexto }}>{n}</button>
          ))}
        </div>

        {docsFiltrados.length === 0
          ? <div style={{ textAlign: "center", padding: "4rem", color: "#aaa" }}>
              <p style={{ fontSize: "40px" }}>📁</p>
              <p style={{ fontSize: "15px", color: texto }}>No hay documentos registrados</p>
              <p style={{ fontSize: "13px" }}>Hacé clic en "+ Nuevo" para comenzar</p>
            </div>
          : docsFiltrados.map(d => (
              <div key={d.id} onClick={() => { setDetalle(docs.find(x => x.id === d.id) || d); setVista("detalle"); }}
                style={{ background: cardBg, borderRadius: "12px", padding: "1.2rem 1.5rem", border: `1px solid ${borde}`, marginBottom: "10px", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <span style={{ fontWeight: "700", color: "#7B5BF2", fontSize: "13px" }}>{d.codigo}</span>
                    <span style={{ marginLeft: "10px", fontSize: "13px", color: texto, fontWeight: "600" }}>{d.titulo || "Sin título"}</span>
                    <p style={{ fontSize: "11px", color: subtexto, marginTop: "4px" }}>{d.norma} · v{d.version || "1.0"}</p>
                  </div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: estadoDocColor[d.estado] || "#808085" }}>{estadoDocLabel[d.estado] || "—"}</span>
                </div>
                <div style={{ marginTop: "6px", fontSize: "11px", color: oscuro ? "#7B5BF2" : "#9b8cc4" }}>
                  {d.responsable && `Responsable: ${d.responsable} · `}Vigencia: {d.fechaVigencia || "—"}
                </div>
              </div>
            ))
        }
      </div>
    </div>
  );
}